export default {
    install(Vue) {
        const permissions = JSON.parse(document.getElementById('app').dataset.userPermissions || '[]');
        const userRole = document.getElementById('app').dataset.userRole || '';

        Vue.prototype.$can = (role) => {
            return permissions.includes(role);
        };

        Vue.prototype.$hasRole = (role) => {
            return userRole === role;
        };

        Vue.prototype.$isSystemAdmin = () => {
            return Vue.prototype.$hasRole('Admin Geral');
        };
    }
};
